import makeStyles from '@mui/styles/makeStyles';

const useEstimationStyles = makeStyles({
  root: {},
  estimationButton: {
    width: '100%', boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)", height: '56px',
    backgroundColor: 'rgba(145, 215, 250, 0.29)',
    borderRadius: '30px',
    border: 'none',
    textAlign:'center',
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  }
});

export default useEstimationStyles;
